import { CmsImageResponse } from '~/types/cms/CmsImageResponse';

const cmsImageToUrl = (
  cmsImage: CmsImageResponse,
) => {
  return cmsImage.url?.replace(/\s/g, '%20');
};

export default cmsImageToUrl;
